import { createContext } from 'utils/create-context';
import noop from 'utils/noop';

import { CartState } from './types';

const initialState: CartState = {
  debug: false,
  isContinueLoading: false,
  isStoreRepricingVisible: false,
  validateCartNow: noop,
  requestCartValidation: noop,
};

const [CartProvider, useCartState] = createContext('Cart', initialState);

export { CartProvider, useCartState };
